import { memo } from 'react';
import ogreDown  from './ogre-boss/ogre-boss-down.png';
import ogreUp    from './ogre-boss/ogre-boss-up.png';
import ogreLeft  from './ogre-boss/ogre-boss-left.png';
import ogreRight from './ogre-boss/ogre-boss-right.png';

const DIR_MAP = {
  up:    ogreUp,
  down:  ogreDown,
  left:  ogreLeft,
  right: ogreRight,
};

function toDir(dx, dy) {
  if (Math.abs(dx) < 0.5 && Math.abs(dy) < 0.5) return 'down';
  if (Math.abs(dy) >= Math.abs(dx)) return dy < 0 ? 'up' : 'down';
  return dx < 0 ? 'left' : 'right';
}

/**
 * Directional ogre-boss PNG sprite.
 * Props:
 *   dx / dy — vector boss-centre → player-centre (for facing direction)
 *   size    — rendered width & height in px
 */
export const OgreBossSprite = memo(function OgreBossSprite({ dx, dy, size }) {
  const dir = toDir(dx, dy);
  return (
    <img
      src={DIR_MAP[dir]}
      width={size}
      height={size}
      style={{ display: 'block', imageRendering: 'pixelated' }}
      alt=""
    />
  );
});
